import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import {getToken} from '@/utils/auth.js'

// create an axios instance
var url = window.self.location.toString();
var newUrl = url.substring(0, url.indexOf("/", url.indexOf("://", 0) + 3));

// var new_Url = newUrl == 'http://localhost:8013' ? 'https://mallyi.quickbusiness.cn/data/' : 'https://www.zhuowendata.com/data/'
console.log(newUrl);
const service = axios.create({
  baseURL: newUrl == 'https://www.zhuowendata.com' ? 'https://www.zhuowendata.com/data/' : 'https://dev.quickbusiness.cn/data/', // url = base url + request url
  // baseURL: 'https://www.zhuowendata.com/apis', // url = base url + request url
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (getToken()) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Token'] = getToken()
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
      // config.headers['Authorization'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const code = response.status
    if (code < 200 || code > 300) {
      Message({
        message: response.message || 'Error',
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    let code = 0
    try {
      code = error.response.data.code
    } catch (e) {
      if (error.toString().indexOf('Error: timeout') !== -1) {
        Message({
          message: '网络请求超时',
          type: 'error',
          duration: 3 * 1000
        })
        return Promise.reject(error)
      }
      if (error.toString().indexOf('Error: Network Error') !== -1) {
        Message({
          message: '网络请求错误',
          type: 'error',
          duration: 3 * 1000
        })
        return Promise.reject(error)
      }
    }
    if (code === 401) {
      MessageBox.confirm(
        '登录状态已过期，您可以继续留在该页面，或者重新登录',
        '系统提示',
        {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        store.dispatch('user/resetToken').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      })
    } else if (code === 400) {
      MessageBox.confirm('网络错误')
    } else if (code === 403) {
      router.push({ path: '/401' })
    } else {
      console.log(error, '错误')
      const errorMsg = error.response.data.message
      if (errorMsg !== undefined) {
        Message({
          message: errorMsg,
          type: 'error',
          duration: 3 * 1000
        })
      }
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/requestA.js